import { Helmet } from "react-helmet";

const SEO = ({
  title = "OpenMind | Open Source AI Robot Operating System | OM1 + FABRIC",
  description = "Open Source AI Robot Operating System | OM1 + FABRIC",
  canonical = "https://openmind.org",
  keywords = "openmind, om1, fabric, ai, robot, operating system, open source, robot operating system, ai robot operating system, om1 fabric, AI-native operating system, open-source robotics, humanoid intelligence, collaborative AI, embodied AI, AI for education, human-machine collaboration, programmable robots, AI-powered learning, next-gen robotics platform, AI literacy, future of work, hands-on STEM, coding with robots, robotics curriculum, real-world learning, AI in classrooms, intelligent machines in education, open infrastructure, decentralized robotics, public benefit AI, open protocol for robots, AI education for all, community-driven AI, robotics for good, verifiable model behavior",
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={canonical} />
    <meta name="keywords" content={keywords} />
    <html lang="en" />

    {/* Open Graph for social sharing */}
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={canonical} />
    <meta property="og:type" content="website" />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
  </Helmet>
);

export default SEO;
